import {createSelector} from 'reselect';
import {getExperiment} from './ExperimentSelectors';
import {getSettings, getSelectedDeliveryCountry} from './selectors';

export default createSelector(
  [getExperiment, getSettings, getSelectedDeliveryCountry],
  (experiment,
    settings,
    deliveryCountry) => (
    !!settings?.enable_collapsed_optional_fields
      || experiment?.optional_address_fields_collapsed_wave_01 === 'v1|optional_address_fields_collapsed'
  ) && deliveryCountry === 'GB',
);
